import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import TableWithSkeleton from '../../../components/global/table/TableWithSkeleton.jsx';
import MyPagination from '../../../components/global/pagination/Pagination.jsx';
import columns from '../../../columns/EmailMarketing.js';
import { GetEmailDetailApi } from '../../../api/request/emailMarketing.js';
import Eye from '../../../assets/Eye.jsx';
import useModulePermissions from '../../../hooks/useModulePermissions.jsx';

const EmailMarketing = () => {

    const emailMarketingPermissions = useModulePermissions('email_marketing');
    const canCreate = !!emailMarketingPermissions.create;

    const navigate = useNavigate();
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);

    const getEmailDetails = async () => {
        const params = {
            PageNumber: page,
            PageSize: pageSize,
        }

        try {
            setIsLoading(true);
            const { data } = await GetEmailDetailApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        const statusText = item?.status || '--';
                        const isCompleted = String(statusText).toLowerCase() === 'completed';
                        const isProcessing = String(statusText).toLowerCase() === 'processing';

                        return {
                            ...item,
                            createdDate: item?.scheduledTime
                                ? moment(item?.scheduledTime).format("DD-MM-YYYY, hh:mm A")
                                : moment(item?.createdDate).format("DD-MM-YYYY, hh:mm A"),
                            attachmentURL: item?.attachmentURL ?
                                (<a href={item?.attachmentURL} target="_blank" rel="noreferrer" className="text-blue-600 underline" >View Attachment</a>)
                                : '--',
                            action: (
                                <div className="flex">
                                    <button type="button" onClick={() => navigate(`/email_marketing/user_detail/${item?.templateId || item?.sendEmailId}`)} ><Eye /></button>
                                </div>
                            ),
                            body: (
                                <button type="button" onClick={() => navigate('/email_marketing/preview',
                                    { state: { body: item?.body, subject: item?.subject, sendEmailId: item?.sendEmailId, }, })}
                                    className="text-blue-600 underline">
                                    Preview
                                </button>
                            ),
                            status: (
                                <span className={`px-3 py-1 rounded-full uppercase text-xs text-center 
                                        ${isCompleted ? 'success_tag' : isProcessing ? 'bg-yellow-200 text-yellow-700' : 'fail_tag'}`} >
                                    {statusText}
                                </span>
                            ),
                        }
                    }
                    ))
                setTotalRecord(data?.totalItems);
            }
            setIsLoading(false);
        }
        catch (error) {
            setIsLoading(false);
        }
    }
    useEffect(() => {
        getEmailDetails();
    }, [page, pageSize]);

    return (
        <div>
            {canCreate && <div className="flex justify-end flex-wrap gap-5">
                <button className="flex items-center bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover  duration-500"
                    onClick={() => navigate(`/email_marketing/new`)}>
                    Add Email
                </button>
            </div>}
            <div className="border-2 border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
                <div className="px-4 lg:px-6">
                    <p className="text-[#2F2B3D] text-xl font-semibold">Email Marketing</p>
                </div>
                <div className="my-6">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} />
                    <MyPagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
                </div>
            </div>
        </div>
    )
}

export default EmailMarketing